import { render, staticRenderFns } from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=template&id=5f0c662e&scoped=true"
import script from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=script&lang=js"
export * from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=script&lang=js"
import style0 from "./ExternalePrenotazioniListPresaInCaricoComponent.vue?vue&type=style&index=0&id=5f0c662e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0c662e",
  null
  
)

export default component.exports